export class DeviationDefinition {
  Id: string;
  CompanyId: string;
  Type: string;
  Context: string;
  Name: any;
  CommentEnabled: boolean;
  ImagesEnabled: boolean;
  Finish: boolean;
  Active: boolean;
}
